import { Component, OnInit, Output, EventEmitter, Inject, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormArray, FormControl, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import * as moment from 'moment/moment';

import { SessionStorageService, PageContentService, LoginService, DataService, ParameterConfigService } from '../../core/index.service';
import { UserState, Login } from '../../core/index.model';
import { UserRole } from '../../core/enumtype';
import { setTimeout } from 'timers';
import { element } from 'protractor';

@Component({
    selector: 'shared-login',
    templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {

    public loginForm: FormGroup;

    message: string;
    isError: boolean;
    isAlert: boolean;
    isWarning: boolean;
    showLoading: boolean;
    currPanelName: string;
    focusEmail: boolean = false;
    email: string;
    linkURL: any;
    userState: UserState;

    constructor(
        private router: Router,
        private fb: FormBuilder,
        private loginService: LoginService,
        private pcService: PageContentService,
        private storageService: SessionStorageService,
        private paramConfigService: ParameterConfigService,
        private dataService: DataService,
        public dialogRef: MatDialogRef<LoginComponent>,
        private renderer: Renderer2,
        @Inject(MAT_DIALOG_DATA) public data: any
    )
    {
        if (data) {
            this.email = data.message.email;
            this.linkURL = data.message.RouterLink;
        }
    }

    ngOnInit() {
        this.formGroup();
        this.showPanel('login');
    }

    closeModal(): void {
        this.dialogRef.close();
    }

    // From Control Group

    formGroup() {
        this.loginForm = this.fb.group({
            UserName: [this.email ? this.email : null, Validators.required],
            Password: [null, Validators.required],
            RememberMe: []
        });

        if (this.email)
            document.getElementById("userNameDiv").classList.remove('is-empty');
    }

    // Profile Update:

    cmdLogin(model: Login, isValid: boolean) {
        
        this.pcService.pageContentYN = true;

        if (isValid) {          
            this.loginService
                .login(model.UserName, model.Password, this.storageService.getJurisNo())
                .then(response => {                   
                    if (response.IsValid) {

                        if (response.RegStatus == "N") {
                            
                            // Redirect to Change Password

                            this.dataService.setPostData({
                                email: model.UserName,
                                tempPwd: model.Password
                            });

                            let link = ['citizen/changepassword/' + response.CitizenID];

                            this.router.navigate(link)
                                .then(success => {
                                    if (success) {
                                        this.showLoading = false;
                                        this.pcService.pageContentYN = false;
                                    }
                                })
                                .catch(err => {
                                    this.showLoading = false;
                                    this.pcService.pageContentYN = false;
                                });

                        }
                        else {
                            
                            // Assign to Session Storage
                            //this.storageService.setUserToken(response.Token);
                            this.storageService.logIn(UserRole.Citizen, response.CitizenID, response.FirstName, response.Email, response.Token, response.pawnMenu, response.RegStatus);

                            // Redirect to Requested URL  
                            let link = [];
                            let PDFForm_linkURL = this.storageService.getRequestFormUrl();
                            if (this.linkURL != null && this.linkURL != "undefined")
                            {
                                link = this.linkURL ? [this.linkURL] : ['citizen/myaccount'];
                            }
                            else if (PDFForm_linkURL != null && PDFForm_linkURL != "undefined")
                            {
                                link = PDFForm_linkURL.indexOf('services/servicejobapp') !== -1 ? [PDFForm_linkURL] : ['citizen/myaccount'];

                            }
                            else
                            {
                                link = ['citizen/myaccount'];
                            }
                            this.router.navigate(link)
                                .then(success => {
                                    if (success) {
                                        this.showLoading = false;
                                        this.pcService.pageContentYN = false;
                                    }
                                })
                                .catch(err => {
                                    this.showLoading = false;
                                    this.pcService.pageContentYN = false;
                                });
                        }

                        this.closeModal();
                    }
                    else {
                        this.showLoading = false;
                        this.pcService.pageContentYN = false;
                        this.showAlert(this.pcService.getKeyTxt('Msg_LoginInCorrect', this.storageService.getLang()), true, true);
                    }
                })
                .catch(err => {
                    this.showLoading = false;
                    this.pcService.pageContentYN = false;
                    this.showAlert(err, true);
                });

        }
        else {
            this.showLoading = false;
            this.pcService.pageContentYN = false;
            this.showAlert(this.pcService.getKeyTxt('Msg_LoginMandatory', this.storageService.getLang()), true, true);
        }

    }

    // Show Alert

    showAlert(strMsg: string, isErr: boolean, showWarning: boolean= false) {
        this.isAlert = true;
        this.isError = isErr;
        this.isWarning = showWarning;
        this.message = strMsg;
    }

    // Close Alert

    closeAlert() {
        this.isAlert = false;
    }


    cmdRegister() {

        //this.showLoading = true;
        this.pcService.pageContentYN = true;

        if (window.location.href.indexOf("citizen/register") > 0) {
            this.showLoading = false;
            this.pcService.pageContentYN = false;
        }

        let link = ['citizen/register'];
        this.router.navigate(link)
            .then(success => {
                if (success) {
                    this.showLoading = false;
                    this.pcService.pageContentYN = false;
                }
            })
            .catch(err => {
                this.showLoading = false;
                this.pcService.pageContentYN = false;
            });


        this.closeModal();
    }

    showPanel(panelName: string) {
        this.currPanelName = panelName;

        if (panelName == "login") {
            const element = this.renderer.selectRootElement("#inputUserName");
            setTimeout(() => element.focus(), 0);

            this.focusEmail = false;
        }
        else {
            this.focusEmail = true;
        }
    }
}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/login/login.component.ts